module.exports = __webpack_public_path__ + "assets/img/kid-bouyancy-aid.28120e0f.png";